import { ComponentRef, Injectable, ViewContainerRef } from '@angular/core';

import { OAuthService } from 'angular-oauth2-oidc';
import { isNumber, isObject, isString } from 'util';

import { LightboxService } from '@gosuite/lightbox';

import { NewsDialogComponent } from './news-dialog.component';
import { isMobileDevice } from '../../services/mobile-device-detector';



@Injectable()
export class NewsDialogService {
	public constructor(
		private _oAuthService: OAuthService,
		private _lightboxService: LightboxService,
	) {}

	public openNewsDialog(newsId: string, viewContainer: ViewContainerRef, options: Partial<NewsDialogComponent> = {}): void {
		const claims = this._oAuthService.getIdentityClaims();

		if (isObject(claims) && isObject(claims['user']) && isNumber(claims['user']['id'])) {
			const newsCacheId: string = 'news:' + claims['user']['id'];
			const jsonStringCache: string = localStorage.getItem(newsCacheId);
			const newsCache: Array<string> = isString(jsonStringCache) && jsonStringCache.length ? JSON.parse(jsonStringCache) : [];
			const showNewsDialog: boolean = !isMobileDevice() && (!newsCache.length || newsCache.indexOf(newsId) === -1);

			if (showNewsDialog) {
				const dialog: NewsDialogComponent = (this._lightboxService.create(viewContainer, NewsDialogComponent) as ComponentRef<NewsDialogComponent>).instance;

				dialog.newsId = newsId;

				dialog.onClose.subscribe(() => {
					newsCache.push(newsId);
					localStorage.setItem(newsCacheId, JSON.stringify(newsCache));
				});

				Object.keys(options).forEach(opt => {
					if (dialog[opt]) {
						dialog[opt] = options[opt];
					}
				});

				dialog.open();
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/shared/components/news-dialog/news-dialog.service.ts